/* ============
 * Actions for the vivemas module
 * ============
 *
 * The actions that are available on the
 * vivemas module.
 */
import axios from 'axios'

// Con APIGEE_API_KEY la web llama al proxy api-ux-web-claims de Apigee (API_UTILITIES = .../web/claims/v1),
// que exige la API key y las cabeceras de trazabilidad. Sin ella llama directo al Cloud Run
// (API_UTILITIES = .../api/v1.0), como antes de la migración.
const useApigee = !!process.env.APIGEE_API_KEY

function transactionId () {
  if (window.crypto && window.crypto.randomUUID) {
    return window.crypto.randomUUID()
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    const r = Math.random() * 16 | 0
    return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16)
  })
}

function apigeeHeaders (processId) {
  if (!useApigee) {
    return {}
  }
  return {
    'x-api-key': process.env.APIGEE_API_KEY,
    'Transaction-ID': transactionId(),
    'Application-ID': 'frontend-siniestros',
    'Process-ID': processId,
    'Artifact-Chain': 'frontend-siniestros'
  }
}

export default {
  saveSinister ({ commit, dispatch }, item) {
    const api = process.env.API_UTILITIES + (useApigee ? '/claims' : '/sinister/save')
    return new Promise((resolve, reject) => {
      const config = {
        headers: {
          'Content-Type': 'multipart/form-data; boundary=' + item._boundary, // `multipart/form-data; boundary=${item._boundary}`
          ...apigeeHeaders('registro-siniestro')
        }
      }
      axios.post(api, item, config)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  getSinister ({ commit, dispatch }, item) {
    const api = process.env.API_UTILITIES + (useApigee ? '/claims/' : '/sinister/get/') + item
    return new Promise((resolve, reject) => {
      axios.get(api, { headers: apigeeHeaders('consulta-siniestro') })
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/sinisters/actions.js